import Vue from 'vue';
import Router from 'vue-router';
import SignInView from '@/views/SignInView';
import SignUpView from '@/views/SignUpView';
import ForgotPasswordView from '@/views/ForgotPasswordView';
import DashboardView from '@/views/DashboardView';
import ListView from '@/views/ListView';
import TableView from '@/views/TableView';
import CatalogView from '@/views/CatalogView';

Vue.use(Router);

export default new Router({
    routes: [
        { name: 'signin', path: '/signin', component: SignInView },
        { name: 'signup', path: '/signup', component: SignUpView },
        { name: 'forgot-password', path: '/forgot-password', component: ForgotPasswordView },
        { name: 'dashboard', path: '/', component: DashboardView },
        { name: 'list', path: '/list', component: ListView },
        { name: 'table', path: '/table', component: TableView },
        { name: 'catalog', path: '/catalog/:id?', component: CatalogView },
        { path: '*', redirect: '/' }
    ]
});



// WEBPACK FOOTER //
// ./src/router.js